import { IPromise } from "angular";
import { TimelineGroup } from "vis-timeline";
import { WithComponent } from "../../../../ui/modelComponentSelector";
import { TimelineDataItem } from "../../../../ui/vis-timeline/api";

export interface DetailTimelineDataItem<TData>
  extends TimelineDataItem<TData>, WithComponent {}

export interface ProcessTimelineItemSourceInitializeArgs<
  TGroup extends TimelineGroup,
> {
  name: string;
  groups: TGroup[];
}

export interface ITimelineItemSource<
  TGroup extends TimelineGroup,
  TArgs extends ProcessTimelineItemSourceInitializeArgs<TGroup>,
> {
  getSourceItems: (initializeArgs: TArgs) => IPromise<TimelineDataItem[]>;
}

export type CreateInterval<TData> = Partial<TimelineDataItem<TData>> &
  Pick<
    TimelineDataItem<TData>,
    "group" | "start" | "content" | "data" | "type"
  >;

export abstract class TimelineItemSource<
  TGroup extends TimelineGroup,
  TArgs extends ProcessTimelineItemSourceInitializeArgs<TGroup>,
  TData,
  TDataItem extends TimelineDataItem<TData>,
> implements ITimelineItemSource<TGroup, TArgs> {
  constructor() {}
  abstract getSourceItems(
    initializeArgs: TArgs,
  ): IPromise<TimelineDataItem<TData>[]>;

  protected defaultTimelineItem<TData>(
    create: CreateInterval<TData>,
  ): TimelineDataItem<TData> {
    return {
      ...create,
    };
  }

  protected abstract createTimelineDataItem(
    args: CreateInterval<TData>,
  ): TDataItem;

  protected styleItems(
    items: TimelineDataItem<unknown>[],
    groups: TimelineGroup[],
  ) {
    const itemGroupPairs = items.reduce(
      (result, current) => {
        result.push({
          item: current,
          group: groups.find((g) => g.id === current.group),
        });

        return result;
      },
      <{ item: TimelineDataItem<unknown>; group?: TimelineGroup }[]>[],
    );
    for (const itemGroup of itemGroupPairs) {
      const treeLevel = (<any>itemGroup.group)?.treeLevel;
      if (treeLevel === undefined) continue;

      itemGroup.item.className = `vis-item-level-${treeLevel}`;
    }
  }
}
